import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
import { S3UploadResponse } from './useInvoiceS3UploadApi';

const useImportS3Url = () => {
  const call = useCallback(
    (params?: { name: string }) =>
      axiosInstance.post<S3UploadResponse>(api.getImportsS3Url(params?.name)),
    []
  );
  const { execute, isLoading } = useAsync(call, false);

  return { execute, s3Loading: isLoading };
};
export default useImportS3Url;
